// extracted by mini-css-extract-plugin
export default {"info":"profile-change-pwd_info__zc+Fw","form":"profile-change-pwd_form__xnJvY","datos":"profile-change-pwd_datos__auk2G","buttonContent":"profile-change-pwd_buttonContent__sd+lJ"};